import { defineMessages } from 'react-intl';

const messages = defineMessages({
  verified: {
    description: 'verification status label verified',
    defaultMessage: 'Verified',
    id: 'GsJjgn',
  },
  verifiedBy: {
    description: 'verification status label tooltip verified by',
    defaultMessage: 'Verified by {userName}',
    id: '8NWtJo',
  },
});

export default messages;
